module.exports = __webpack_public_path__ + "img/index.dfb6cb4a.jpg";